import { useState, useEffect } from "react";
import { Link } from "wouter";
import { Menu, X, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { servicesData } from "@/data/services";
import logoImg from "@assets/1000018485_1776909210457.png";
import { useQuote } from "@/components/QuoteProvider";

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { openQuote } = useQuote();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav aria-label="Main navigation" className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? "bg-[#0A0F1C]/95 backdrop-blur-md shadow-md py-4" : "bg-transparent py-6"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <Link href="/" className="flex items-center gap-3">
            <img src={logoImg} width={32} height={32} alt="" decoding="async" className="h-8 w-8 object-contain" />
            <span className="font-display font-bold text-xl text-white tracking-tight">All In Solutions</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link href="/" className="text-sm font-semibold text-white hover:text-blue-500 transition-colors">Home</Link>
            
            <div className="relative group cursor-pointer">
              <button type="button" className="text-sm font-semibold text-slate-300 hover:text-white transition-colors flex items-center gap-1 py-2">
                Services <ChevronDown className="w-4 h-4 opacity-50" />
              </button>
              <div className="absolute top-[100%] left-0 w-56 bg-white rounded-xl shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus-within:opacity-100 group-focus-within:visible group-focus-within:translate-y-0 transition-all duration-200 transform translate-y-2 group-hover:translate-y-0 z-50 overflow-hidden border border-slate-100">
                {servicesData.map((s) => (
                  <Link key={s.slug} href={`/services/${s.slug}/`} className="block px-4 py-3 text-sm font-medium text-slate-700 hover:bg-blue-50 hover:text-blue-600 transition-colors">
                    {s.title}
                  </Link>
                ))}
              </div>
            </div>

            <Link href="/catalogue/" className="text-sm font-semibold text-slate-300 hover:text-white transition-colors">Catalogue</Link>
            <button onClick={() => {
              if (window.location.pathname !== '/') {
                 window.location.href = '/#why-us';
              } else {
                 document.getElementById('why-us')?.scrollIntoView({behavior: 'smooth'})
              }
            }} className="text-sm font-semibold text-slate-300 hover:text-white transition-colors">About Us</button>
            <button onClick={() => window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth'})} className="text-sm font-semibold text-slate-300 hover:text-white transition-colors">Contact</button>
          </div>

          <div className="hidden md:flex items-center space-x-4">
             <Button onClick={() => openQuote()} className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-6 text-sm font-semibold h-10 border-0">
               Get a Quote
             </Button>
          </div>

          <div className="md:hidden flex items-center">
            <button aria-label={mobileMenuOpen ? "Close navigation" : "Open navigation"} aria-expanded={mobileMenuOpen} aria-controls="mobile-navigation" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white">
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div id="mobile-navigation" className="md:hidden bg-[#0A0F1C] border-t border-slate-800 mt-4 px-4 py-4 space-y-4 shadow-xl">
           <Link href="/" onClick={() => setMobileMenuOpen(false)} className="block text-white font-semibold">Home</Link>
           <div className="text-slate-400 font-semibold mb-2">Services</div>
           <div className="pl-4 space-y-3 mb-4">
             {servicesData.map((s) => (
                <Link key={s.slug} href={`/services/${s.slug}/`} onClick={() => setMobileMenuOpen(false)} className="block text-sm text-slate-300 hover:text-white">
                  {s.title}
                </Link>
             ))}
           </div>
           <Link href="/catalogue/" onClick={() => setMobileMenuOpen(false)} className="block text-white font-semibold">Catalogue</Link>
           <button onClick={() => { setMobileMenuOpen(false); openQuote(); }} className="w-full text-left text-blue-500 font-semibold mt-4">Get a Quote</button>
        </div>
      )}
    </nav>
  );
}
